import React, { useEffect, useRef, useState } from "react";
import MainPagetitle from "../../../layouts/MainPagetitle";
import leaflet from "leaflet";

const LocationHistory = (props) => {
  const applId = props?.urlparams?.params?.applId;
  const customerId = props?.urlparams?.params?.customerId;
  const fromPath = props?.urlparams?.params?.frompath;
  const customerName = props?.urlparams?.params?.customerName;
  const [locationIsFetching, setLocationIsFetching] = useState(true);
  const [locationData, setLocationData] = useState([]);
  const [locationRowcount, setLocationRowcount] = useState(0);
  const locationColumns = [
    {
      dataIndex: "action",
      title: "Location",
      render: (text, record, index) => {
        return (
          <div>
            <h6 className="text-primary">
              {index + 1} - {text?.toTitleCase()}
            </h6>
          </div>
        );
      },
    },
    {
      dataIndex: "latitude",
      title: "Latitude",
    },
    {
      dataIndex: "longitude",
      title: "Longitude",
    },
  ];
  //
  const [recentLocationIsFetching, setRecentLocationIsFetching] =
    useState(true);
  const [recentLocationData, setRecentLocationData] = useState([]);
  const [recentLocationRowcount, setRecentLocationRowcount] = useState(0);
  const recentLocationColumns = [
    {
      dataIndex: "location",
      title: "SL. No.",
      render: (text, record, index) => {
        return (
          <div>
            <h6 className="text-primary">{index + 1}</h6>
          </div>
        );
      },
    },
    {
      dataIndex: "latitude",
      title: "Latitude",
    },
    {
      dataIndex: "longitude",
      title: "Longitude",
    },
    {
      dataIndex: "createdAt",
      title: "Date",
      render: (text, record) => {
        if (record?.createdAt) {
          let date = new Date(record?.createdAt).dateToDDMMYYYY(
            new Date(record?.createdAt)
          );
          return date || "-";
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "time",
      title: "Time",
      render: (text, record) => {
        if (record?.createdAt) {
          let time = new Date(record?.createdAt).toLocaleTimeString();
          return time || "-";
        } else {
          return "-";
        }
      },
    },
  ];

  const getMainTitle = () => {
    let mainTitle = "";
    if (fromPath === "loanApplications") {
      mainTitle = "Loan Applications";
    }
    if (fromPath === "loanDetails") {
      mainTitle = "Loan Details";
    }
    return mainTitle;
  };
  const getBreadCums = () => {
    let pagetitle = "";
    if (fromPath === "loanApplications") {
      pagetitle = `${customerName} Location History`;
    }
    if (fromPath === "loanDetails") {
      pagetitle = `${customerName} Location History`;
    }
    return pagetitle;
  };
  const getBackLink = () => {
    let url;
    if (fromPath === "loanApplications") {
      url = "/app/loanapplications?activetab=inprogress";
    }
    if (fromPath === "loanDetails") {
      url = "/app/loandetails?activetab=active&producttype=BULLET";
    }
    return url;
  };

  const getLocations = () => {
    let payload = {
      action: "SIGNUP,APPLY_LOAN,PROFILE_COMPLETION,POST_SANCTIONED",
      applicationId: applId,
    };
    let urlData = {
      customerId: customerId,
    };
    props.apis
      .apiGetCustomerLocationLogs(payload, urlData)
      .then(({ data, total }) => {
        if (data) {
          setLocationIsFetching(false);
          setLocationData(data);
          setLocationRowcount(total);
        }
      });
  };

  const getRecentLocations = () => {
    let payload = {
      action: "SIGNIN",
      applicationId: applId,
      limit: 10,
    };
    let urlData = {
      customerId: customerId,
    };
    props.apis
      .apiGetCustomerLocationLogs(payload, urlData)
      .then(({ data, total }) => {
        if (data) {
          setRecentLocationIsFetching(false);
          setRecentLocationData(data);
          setRecentLocationRowcount(total);
        }
      });
  };

  useEffect(() => {
    getLocations();
    getRecentLocations();
  }, []);

  return (
    <>
      <MainPagetitle
        mainTitle={getMainTitle()}
        back={getBreadCums()}
        backLink={getBackLink()}
        pageTitle={"Know Your Customer"}
        parentTitle={"Home"}
        pageIcon={imagepaths.applicationCheckActiveImg}
      />

      <div className="container-fluid">
        <h2 className="mb-3 fs-4">Location</h2>
        <div className="row">
          <div className="col-12 col-lg-7">
            <div className="card">
              <LocationhistoryMap data={locationData} />
            </div>
          </div>
          <div className="col-12 col-lg-5">
            <AppTable
              data={locationData}
              columns={locationColumns}
              total={locationRowcount}
              reorder={true}
              editable={false}
              viewable={false}
              deletable={false}
              showPagination={false}
              loading={locationIsFetching}
            ></AppTable>
          </div>
        </div>
        <hr />
        <h2 className="mb-3 fs-4">Recent Logins Location</h2>

        <div className="row">
          <div className="col-12 col-lg-7">
            <div className="card">
              <RecentLocationhistoryMap data={recentLocationData} />
            </div>
          </div>
          <div className="col-12 col-lg-5">
            <AppTable
              data={recentLocationData}
              columns={recentLocationColumns}
              total={recentLocationRowcount}
              reorder={true}
              editable={false}
              viewable={false}
              deletable={false}
              showPagination={false}
              loading={recentLocationIsFetching}
            ></AppTable>
          </div>
        </div>
      </div>
    </>
  );
};

export default constore(LocationHistory);

function LocationhistoryMap({ data }) {
  const mapRef = useRef();
  const markerRef = useRef();

  const getLocationByAction = (data, action) => {
    return data?.filter((v) => v?.action === action)[0] || {};
  };

  useEffect(() => {
    console.log({ data });

    let container = leaflet.DomUtil.get("locationHistoryMap");
    if (container != null) {
      container._leaflet_id = null;
    }

    if (data?.length > 0) {
      let applyLoan = getLocationByAction(data, "APPLY_LOAN");
      let signUp = getLocationByAction(data, "SIGNUP");
      let profileCompletion = getLocationByAction(data, "PROFILE_COMPLETION");
      let postSanctioned = getLocationByAction(data, "POST_SANCTIONED");
      console.log({ data, applyLoan });

      let fData = [
        ["Signup", signUp?.latitude, signUp?.longitude],
        [
          "Profile Completion",
          profileCompletion?.latitude,
          profileCompletion?.longitude,
        ],
        ["Apply Loan", applyLoan?.latitude, applyLoan?.longitude],
        [
          "Post Sanctioned",
          postSanctioned?.latitude || 0,
          postSanctioned?.longitude || 0,
        ],
      ];

      mapRef.current = leaflet
        .map("locationHistoryMap")
        .setView([applyLoan?.latitude, applyLoan?.longitude], 12);

      leaflet
        .tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
          maxZoom: 19,
          attribution:
            '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        })
        .addTo(mapRef.current);

      for (let i = 0; i < fData?.length; i++) {
        const number = i + 1;

        const numberedIcon = leaflet.divIcon({
          html: `
          <div class="custom-marker">
            <div class="number">${number}</div>
          </div>
        `,
          iconSize: [30, 40],
          iconAnchor: [15, 40],
          popupAnchor: [0, -40],
          className: "", // prevents Leaflet from applying default styles
        });

        markerRef.current = new leaflet.marker([fData[i][1], fData[i][2]], {
          icon: numberedIcon,
        })
          .bindPopup(fData[i][0])
          .addTo(mapRef.current);
      }
    }
  }, [data]);

  return <div id="locationHistoryMap" ref={mapRef}></div>;
}

function RecentLocationhistoryMap({ data }) {
  const mapRef = useRef();
  const markerRef = useRef();

  const getLocationByAction = (data, action) => {
    return data?.filter((v) => v?.action === action)[0] || {};
  };

  useEffect(() => {
    console.log({ "RECENT LOCATIONS": data });

    let container = leaflet.DomUtil.get("recentLocationHistoryMap");
    if (container != null) {
      container._leaflet_id = null;
    }

    if (data?.length > 0) {
      let signIn = getLocationByAction(data, "SIGNIN");

      let fData = data?.map((v, i) => [
        "Location " + (i + 1),
        v?.latitude,
        v?.longitude,
      ]);

      mapRef.current = leaflet
        .map("recentLocationHistoryMap")
        .setView([data[0]?.latitude, data[0]?.longitude], 12);

      leaflet
        .tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
          maxZoom: 19,
          attribution:
            '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        })
        .addTo(mapRef.current);

      console.log({ data, signIn, fData });
      for (let i = 0; i < fData?.length; i++) {
        const number = i + 1;

        const numberedIcon = leaflet.divIcon({
          html: `
          <div class="custom-marker">
            <div class="number">${number}</div>
          </div>
        `,
          iconSize: [30, 40],
          iconAnchor: [15, 40],
          popupAnchor: [0, -40],
          className: "", // prevents Leaflet from applying default styles
        });

        markerRef.current = new leaflet.marker([fData[i][1], fData[i][2]], {
          icon: numberedIcon,
        })
          .bindPopup(fData[i][0])
          .addTo(mapRef.current);
      }
    }
  }, [data]);

  return <div id="recentLocationHistoryMap" ref={mapRef}></div>;
}
